import React from 'react';
import { PaymentHistoryItem, PaymentRecordState } from './payment-history.types';

const getButtonStateClass = (state: PaymentRecordState): string => {
   if (state === 'DEACTIVATED') {
      return 'deactivated';
   }

   if (state === 'PENDING') {
      return 'pending';
   }

   return '';
};

export const PaymentStatusMarker = ({
   item,
   onOpen,
}: {
   item: PaymentHistoryItem;
   onOpen: (item: PaymentHistoryItem) => void;
}) => {
   return (
      <button
         type="button"
         onClick={() => {
            onOpen(item);
         }}
         className={`btn paymentButton ${getButtonStateClass(item.state)}`}
      >
         {item.plan_name}
      </button>
   );
};
